import { gql } from "apollo-boost"

export const getSubmissionBasicInfo = gql`
  query SubmissionBasicInfo($id: ID!) {
    SubmissionBasicInfo(id: $id) {
      state
      name
      allies
      alliedOne
      alliedTwo
      status
      startDate
      endDate
      implementer {
        name
        email
      }
    }
  }
`